// extracted by mini-css-extract-plugin
module.exports = {"badgeContainer":"OfferRecreate_badgeContainer_oCJ4u"};